<script setup>
import { trans } from '@tools/translation';

const emit = defineEmits([ 'click' ]);
</script>

<template>
  <div class="team-view__actions">
    <button
      class="btn btn--primary team-view__actions--add"
      @click.prevent="emit('click')"
    >
      {{ trans('user.organization.team.invite_member') }}
    </button>
  </div>
</template>
